import { maintenanceForwardingEntryTypeLabel } from '@shared/maintenance/forwardingEntryLabels'
import {
  ManualEntryProposalCardItem,
  ManualEntryProposalColumnStatus,
  ManualEntryProposalData,
} from '../types/maintenanceManualEntryProposal.type'

export class MaintenanceManualEntryProposalsTransformer {
  static cardsTransformer(status: ManualEntryProposalColumnStatus) {
    return (proposals: ManualEntryProposalData[]): ManualEntryProposalCardItem[] =>
      proposals.map((proposal) => {
        const forwarding = proposal.manual_entry?.forwarding

        const base: ManualEntryProposalCardItem = {
          id: proposal.id,
          forwardingType: maintenanceForwardingEntryTypeLabel(forwarding?.directive_entry_type),
          equipmentModel: forwarding?.workflow?.equipment?.model?.display_name || '--',
          companyName: forwarding?.workflow?.company?.general_information?.fantasy_name || '--',
          createdAt: proposal.created_at,
        }

        if (status === 'completed') {
          return { ...base, finalState: 'accepted' }
        }

        if (status === 'canceled') {
          if (proposal.establishment_rejected_at) {
            return { ...base, finalState: 'rejected', rejectedBy: 'establishment', finalizedAt: proposal.establishment_rejected_at }
          }

          if (proposal.client_rejected_at) {
            return { ...base, finalState: 'rejected', rejectedBy: 'client', finalizedAt: proposal.client_rejected_at }
          }

          return { ...base, finalState: 'cancelled' }
        }

        return base
      })
  }
}
